import { motion, useScroll, useTransform } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import SmoothScroll from "@/components/fl/SmoothScroll";
import Hero from "@/components/fl/Hero";
import ProfileHeader from "@/components/fl/ProfileHeader";
import Highlights from "@/components/fl/Highlights";
import PostGrid from "@/components/fl/PostGrid";
import EditorialMarquee from "@/components/fl/EditorialMarquee";
import ManifestoChapters from "@/components/fl/ManifestoChapters";
import ContactSection from "@/components/fl/ContactSection";
import Footer from "@/components/fl/Footer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HERO_IMAGE = "/brand/hero.jpg";
const AVATAR_IMAGE = "/brand/logo-circle.jpg";
const LOGO_SQUARE = "/brand/logo-square.jpg";

export default function Home() {
  const [profile, setProfile] = useState(null);
  const [posts, setPosts] = useState([]);
  const [highlights, setHighlights] = useState([]);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const [p, po, h] = await Promise.all([
          axios.get(`${API}/profile`),
          axios.get(`${API}/posts`),
          axios.get(`${API}/highlights`),
        ]);
        if (cancelled) return;
        setProfile(p.data);
        setPosts(po.data);
        setHighlights(h.data);
      } catch (e) {
        console.error("Failed to load site data", e);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <SmoothScroll>
      <div className="App grain relative">
        <Hero
          heroImage={HERO_IMAGE}
          onCta={() => scrollTo("contact")}
          onMessage={() => scrollTo("profile")}
        />

        <ProfileHeader
          profile={profile ? { ...profile, avatar: AVATAR_IMAGE } : profile}
          onFollow={() =>
            window.open("https://instagram.com/fairylights.uae", "_blank")
          }
          onMessage={() =>
            window.open("https://wa.me/971528035188", "_blank")
          }
          onContact={() => scrollTo("contact")}
        />

        <Highlights highlights={highlights} />

        <ParallaxSpacer />

        <PostGrid posts={posts} />

        <EditorialMarquee />

        <ManifestoChapters />

        <ContactSection />

        <Footer />
      </div>
    </SmoothScroll>
  );
}

function ParallaxSpacer() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <section ref={ref} className="relative overflow-hidden py-8">
      <motion.div
        style={{ y }}
        className="pointer-events-none mx-auto max-w-5xl px-6 sm:px-10 md:px-14"
      >
        <p className="font-italic-serif text-[6vw] leading-[1.05] text-[#D4AF37]/40 md:text-[3.5vw]">
          &ldquo;Every candle placed like a comma in a poem.&rdquo;
        </p>
      </motion.div>
    </section>
  );
}
